import React from "react";
import ApolloDataExportHistoryComponent from "../Contents/RoverImport/ApolloDataExportAdmin/ApolloDataExportHistoryComponent";
import FaIcon from "../Elements/FaIcon";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import dateTimeHelper from "../Helpers/datetimeHelper";
import JsxHelper from "../Helpers/JsxHelper";
import selectHelper from "../Helpers/selectHelper";

export default class ApolloDataExportItem {
  constructor(item) {
    if (item === undefined) {
      this.ApolloDataExportId = "";
      this.ClientName = "";
      this.Query = "";
      this.EmailRecipients = "";
      this.Frequency = "";
      this.StartDate = dateTimeHelper.toYYYYsMMsDD(new Date());
      this.EndDate = dateTimeHelper.toYYYYsMMsDD(new Date());
      this.IsActive = "true";
      this.LastSentOn = "";
      this.CreatedOn = "";
      this.CreatedBy = "";
      this.CreatedName = "";
      this.ModifiedOn = "";
      this.ModifiedBy = "";
      this.ModifiedName = "";
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.ApolloDataExportId = item.apolloDataExportId;
    this.ClientName = item.clientName;
    this.Query = item.query;
    this.EmailRecipients = item.emailRecipients;
    this.Frequency = item.frequency;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.IsActive = item.isActive;
    this.LastSentOn = item.lastSentOn;
    this.CreatedOn = item.createdOn;
    this.CreatedBy = item.createdBy;
    this.CreatedName = item.createdName;
    this.ModifiedOn = item.modifiedOn;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedName = item.modifiedName;
  }

  static NameOfTheIdField() {
    return "ApolloDataExportId";
  }
  static nameOfTheItemDetailList() {
    return "Apollo Data Export";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = ["StartDate", "EndDate", "LastSentOn", "CreatedOn", "ModifiedOn"];

  static BoolFields = ["IsActive"];

  static FieldsToShowInListTable = [
    {
      tabName: "Info",
      tabLabel: "Info",
      icon: "fa-solid fa-info",
      data: [
        { name: "ApolloDataExportId", label: "ApolloDataExport Id" },
        { name: "EmailRecipients", label: "Email Recipients" },
        { name: "Frequency", label: "Frequency" },
        { name: "Query", label: "Query", width: TabListTableCellWidthEnum.Full },
        { name: "StartDate", label: "Start Date" },
        { name: "EndDate", label: "End Date" },
        { name: "IsActive", label: "Is Active" },
        { name: "LastSentOn", label: "Last Sent On" },
        { name: "-", label: "Users" },
        { name: "CreatedOn", label: "Created On" },
        { name: "CreatedBy", label: "Created By" },
        { name: "CreatedName", label: "Created Name" },
        { name: "ModifiedOn", label: "Modified On" },
        { name: "ModifiedBy", label: "Modified By" },
        { name: "ModifiedName", label: "Modified Name" },
      ],
    },
    {
      tabName: "History",
      tabLabel: "History",
      icon: "fa-solid fa-clipboard",
      data: [{ name: ApolloDataExportItem.GetHstoryCellContent, label: "History", width: TabListTableCellWidthEnum.TwoLines, className: "text-left" }],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: "ApolloDataExport Id", orderById: "ApolloDataExportId", data: "ApolloDataExportId", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 50 },
      { label: "Query Name", orderById: "ClientName", data: "ClientName", className: "text-center", minWidth: 50 },
      { label: "Frequency", orderById: "Frequency", data: "Frequency", className: "text-center", minWidth: 50 },
      { label: "Start Date", orderById: "StartDate", data: ApolloDataExportItem.getStartDateContent, type: FieldTypesEnum.Email, className: "text-center", minWidth: 50 },
      { label: "End Date", orderById: "EndDate", data: ApolloDataExportItem.getEndDateContent, className: "text-center", minWidth: 50 },
      { label: "Is Active", orderById: "IsActive", data: (item) => JsxHelper.YesNo(item.IsActive), className: "text-center" },
      { label: "Actions", orderById: "", data: ApolloDataExportItem.getActionsContent, className: "text-center" },
    ];
  }

  static getStartDateContent(item) {
    return item.Frequency === 'On-Demand' ? '-' : dateTimeHelper.toYYYYsMMsDD(item.StartDate);
  }

  static getEndDateContent(item) {
    return item.Frequency === 'On-Demand' ? '-' : dateTimeHelper.toYYYYsMMsDD(item.EndDate);
  }

  static getActionsContent(item) {
    return (
      <div>
        <FaIcon iconName="fa-solid fa-edit" className="pointer link" tooltipText="Edit" onClick={() => ApolloDataExportItem.editFunction(item.ApolloDataExportId, item)} />{" "}
        <FaIcon
          iconName="fa-solid fa-hand-spock"
          className="pointer link"
          tooltipText="Start On-Demand Export"
          disabled={item.Frequency !== "On-Demand" || item.IsActive !== true}
          onClick={() => ApolloDataExportItem.startExportOnDemand(item.ApolloDataExportId, item)}
        />
      </div>
    );
  }

  static editFunction(id, item) {
    //this is just a placeholder
  }

  static GetQuestionCellContent(item) {
    return (
      <textarea className="w-100" rows={5}>
        {item.Questions}
      </textarea>
    );
  }

  static GetHstoryCellContent(item) {
    return <ApolloDataExportHistoryComponent apolloDataExportId={item.ApolloDataExportId} />;
  }

  static getFrequencySelectOptions() {
    return selectHelper.generateSelectValues(["", "Daily", "Twice-a-week", "Weekly", "Fortnightly", "Monthly", "On-Demand"]);
  }
}
